import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import { createBrowserRouter, RouterProvider } from "react-router-dom";

import App from "./App";
import Dashboard from "./components/licenciados/dashboard/Dashboard";
import Historico from "./components/licenciados/historico/historico";
import DadosBancarios from "./components/licenciados/dadosBancarios/DadosBancarios";
import PedidoSaque from "./components/licenciados/PedidoSaque/PedidoSaque";
import Ajuda from "./components/licenciados/Ajuda/Ajuda";

import Usuarios from "./components/admin/usuarios/Usuarios";
import AddUsuarios from "./components/admin/usuarios/AddUsuarios";
import LancarComissao from "./components/admin/LancarComissao/LancarComissao";

import { AuthProvider } from "./components/auth/AuthContext";
import RequireAuth from "./components/auth/RequireAuth";
import RequireRole from "./components/auth/RequireRole";
import EmBreve from "./components/EmBreve/EmBreve";

const router = createBrowserRouter([
  { path: "/", element: <App /> },
  { path: "/embreve", element: <EmBreve /> },

  {
    element: <RequireAuth />,
    children: [
      // Rotas do LICENSED
      {
        element: <RequireRole allowed={["LICENSED"]} />,
        children: [
          { path: "/dashboard", element: <Dashboard /> },
          { path: "/historico", element: <Historico /> },
          { path: "/dadosbancarios", element: <DadosBancarios /> },
          { path: "/solicitarsaque", element: <PedidoSaque /> },
          { path: "/ajuda", element: <Ajuda /> },
        ],
      },

      // Rotas do ADMIN
      {
        element: <RequireRole allowed={["ADMIN"]} />,
        children: [
          { path: "/usuarios", element: <Usuarios /> },
          { path: "/adicionarusuarios", element: <AddUsuarios /> },
          { path: "/adicionarusuarios/:id", element: <AddUsuarios /> },
          { path: "/lancarcomissao", element: <LancarComissao /> },
        ],
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </React.StrictMode>
);

